import React from 'react';

function ErrorPage() {
    return (
        <div className="m-auto text-center mt-5">
            <h1>Sorry, unable to load editor</h1>
            <p>Please contact support</p>
            <a href="https://tiiny.host/help">tiiny.host/help</a>
        </div>
    );
}

export default ErrorPage;